import { useMemo } from 'react';

import omitBy from 'lodash/omitBy';

import { ListItem, Select, Typography, Box, tokens } from '@cast/design-system';

import { stateCriterion } from '../constants';
import { EdgeLocationMappedState } from '../types';
import { EdgeLocationStateChip } from './EdgeLocationStateChip';

import {
  makeEnumAggregateFn,
  useFiltersDropdownAggregate,
  useSearchCriterion,
} from '@cast/shared-search-ui';

export const EdgeLocationStateFilter = () => {
  const criterion = useSearchCriterion(stateCriterion);

  const { aggregate, dropdownProps } = useFiltersDropdownAggregate(
    stateCriterion.key,
    makeEnumAggregateFn(EdgeLocationMappedState, 'mappedState')
  );

  // Omit filter option if no values exist
  const states = useMemo(
    () => omitBy(aggregate, (value) => value === 0),
    [aggregate]
  );

  return (
    <Select
      testId="edge-location-state-filter"
      options={Object.keys(states) as EdgeLocationMappedState[]}
      inputText="State"
      multiple
      checkable
      sx={{ minWidth: '198px' }}
      value={criterion.value}
      onChange={(option) => {
        if (option?.length) {
          criterion.setValue?.(option);
        } else {
          criterion.clear?.();
        }
      }}
      renderOption={(state, itemProps) => {
        return (
          <ListItem {...itemProps}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              gap="8px"
            >
              <EdgeLocationStateChip state={state} />

              <Typography
                variant="P12R"
                color={tokens.theme.fg.structural.secondary}
                width="3ch"
                textAlign="end"
              >
                {states[state]}
              </Typography>
            </Box>
          </ListItem>
        );
      }}
      {...dropdownProps}
    />
  );
};
